var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Integrations",

    getDefaultProps () {
        return {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>F407746D-3809-4FDE-9671-7C0A47F08FC1</title>
  <desc>Created with sketchtool.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Header-01-EventGroup" transform="translate(-541.000000, -270.000000)" fill="currentColor">
      <g id="Tabs" transform="translate(240.000000, 259.000000)">
        <g id="integrations">
          <g transform="translate(301.000000, 11.000000)">
            <g id="Group-5">
              <path d="M2.00164982,2 C1.72459627,2 1.5,2.22193241 1.5,2.5 L1.5,2.5 C1.5,2.77614237 1.72563934,3 2.00164982,3 L13.9983502,3 C14.2754037,3 14.5,2.77806759 14.5,2.5 L14.5,2.5 C14.5,2.22385763 14.2743607,2 13.9983502,2 L2.00164982,2 L2.00164982,2 Z M3.99669884,0 C3.72237965,0 3.5,0.221932411 3.5,0.5 C3.5,0.776142375 3.72247314,1 3.99669884,1 L12.0033012,1 C12.2776204,1 12.5,0.778067589 12.5,0.5 C12.5,0.223857625 12.2775269,0 12.0033012,0 L3.99669884,0 Z M0,5.00247329 L0,14.9975267 C0,15.5511774 0.444630861,16 1.00087166,16 L14.9991283,16 C15.5518945,16 16,15.5514869 16,14.9975267 L16,5.00247329 C16,4.44882258 15.5553691,4 14.9991283,4 L1.00087166,4 C0.448105505,4 0,4.44851311 0,5.00247329 Z M14.9991283,5 C15.000987,5 15,14.9975267 15,14.9975267 C15,14.9994052 1.00087166,15 1.00087166,15 C0.999013025,15 1,5.00247329 1,5.00247329 C1,5.00059478 14.9991283,5 14.9991283,5 Z" id="Combined-Shape"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/integrations.svg
 **/